var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"language-switcher",on:{"click":_vm.switchHandler}},[_c('span',{class:_vm.lang === 'zh' ? 'selected' : ''},[_vm._v("中")]),_vm._v("\n  |\n  "),_c('span',{class:_vm.lang === 'en' ? 'selected' : ''},[_vm._v("En")])])}
var staticRenderFns = []

export { render, staticRenderFns }